import { render } from "./Hero.vue?vue&type=template&id=15a17a6d&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=js"
export * from "./Hero.vue?vue&type=script&lang=js"

import "./Hero.vue?vue&type=style&index=0&id=15a17a6d&scoped=true&lang=css"
import "./Hero.vue?vue&type=style&index=1&id=15a17a6d&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a17a6d"]])

export default __exports__